module.exports = __webpack_public_path__ + "img/pet-insurance-filled.9faa979.png";